__turbopack_context__.v({
  "BottomBar": "EDcwOW_BottomBar",
  "Container": "EDcwOW_Container",
  "Cover": "EDcwOW_Cover",
  "MiddleBar": "EDcwOW_MiddleBar",
  "Root": "EDcwOW_Root",
  "Root--Cover": "EDcwOW_Root--Cover",
  "TopBar": "EDcwOW_TopBar",
  "skeleton-loading": "EDcwOW_skeleton-loading",
});
